import { Controller } from "stimulus";
import { listboxAction, listboxIndex, selectedIndex } from "../../training_grooming_calendar/listbox";

export default class extends Controller {
  static targets = ["button", "list", "option"];

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    this.listTarget.hidden = false;
    this.buttonTarget.setAttribute("aria-expanded", "true");
    this.element.classList.add("tg-facility-open");
    this.focusOption(Math.max(selectedIndex(this.optionTargets), 0));
  }

  close({ focus = true } = {}) {
    if (!this.isOpen()) return;
    this.listTarget.hidden = true;
    this.buttonTarget.setAttribute("aria-expanded", "false");
    this.element.classList.remove("tg-facility-open");
    if (focus) this.buttonTarget.focus({ preventScroll: true });
  }

  outside(event) {
    if (this.isOpen() && !this.element.contains(event.target)) this.close({ focus: false });
  }

  keydown(event) {
    const action = listboxAction(event.key, this.isOpen());
    if (!action) return;
    if (action === "leave") {
      this.close({ focus: false });
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (action === "open") this.open();
    if (action === "close") this.close();
    if (action === "move") this.focusOption(listboxIndex(this.activeIndex(), event.key, this.optionTargets.length));
    if (action === "pick") {
      const option = this.optionTargets[this.activeIndex()];
      if (option) option.click();
    }
  }

  isOpen() {
    return !this.listTarget.hidden;
  }

  activeIndex() {
    const index = this.optionTargets.indexOf(document.activeElement);
    return index >= 0 ? index : selectedIndex(this.optionTargets);
  }

  focusOption(index) {
    const option = this.optionTargets[index];
    if (option) option.focus({ preventScroll: false });
  }
}
